import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/accessibility.css';
import './styles/accessibilityEnhanced.css';
import App from './App';
import { initKeyboardNavDetection } from './utils/keyboardNavDetection';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Set document language for screen readers
document.documentElement.lang = 'en';

// Initialize keyboard navigation detection
initKeyboardNavDetection();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
